import React from "react";
import "../Orders/Carousel.css";
var Carousel = require("react-responsive-carousel").Carousel;

const basePChildren = (Payments) =>
  Payments.map((payment, index) => (
    <div key={index} className="carusel_oplata">
      <div><p>{payment.years1}</p> </div>
      <div><p>{payment.id_rate}</p></div>
      <div><p>{payment.smeta}</p></div>
      <div><p>{payment.sum_opl}</p></div>
      <div><p>{payment.dolg}</p></div>
      <div><p>{payment.spec1}</p></div>
    </div>
  ));

const getConfigurableProps = () => ({
  showArrows: true,
  showStatus: false,
  showIndicators: true,
  infiniteLoop: true,
  showThumbs: false,
  useKeyboardArrows: true,
  autoPlay: false,
  stopOnHover: true,
  swipeable: true,
  dynamicHeight: false,
  emulateTouch: true,
  thumbWidth: 0,
  // selectedItem: 1,
  interval: 50000,
  transitionTime: 400,
  swipeScrollTolerance: 5,
});
const arrowStyles = {
  position: "absolute",
  zIndex: 2,
  top: "12.5px",
  width: 20,
  height: 20,
  cursor: "pointer",
};

export class BaseCarouselP extends React.Component {
  render() {
    return (
      <Carousel
        {...getConfigurableProps()}
        selectedItem={this.props.payment.length - 1}
        renderArrowPrev={(onClickHandler, hasPrev, label) =>
          hasPrev && (
            <div
              className="Btn_left"
              type="button"
              onClick={onClickHandler}
              title={label}
              style={{ ...arrowStyles, left: 5 }}
            >
              <div className="prev"></div>
            </div>
          )
        }
        renderArrowNext={(onClickHandler, hasNext, label) =>
          hasNext && (
            <div
              className="Btn_right"
              type="button"
              onClick={onClickHandler}
              title={label}
              style={{ ...arrowStyles, right: 5 }}
            >
              <div className="next"></div>
            </div>
          )
        }
      >
        {basePChildren(this.props.payment)}
      </Carousel>
    );
  }
}

const basePrihodChildren = (Payments) =>
  Payments.map((payment, index) => (
    <div key={index} className="carusel_prihod">
      <div><p>{payment.years2}</p> </div>
      <div><p>{payment.prihod}</p></div>
      <div><p>{payment.dates2}</p></div>
      <div><p>{payment.orders2}</p></div>
      <div><p>{payment.vid_opl2}</p></div>
      <div><p>{payment.spec2}</p></div>
      <div><p>{payment.uslugi2}</p></div>
    </div>
  ));

export class PrihodCarouselP extends React.Component {
  render() {
    return (
      <Carousel
        {...getConfigurableProps()}
        selectedItem={this.props.payment.length - 1}

        renderArrowPrev={(onClickHandler, hasPrev, label) =>
          hasPrev && (
            <div
              className="Btn_left"
              type="button"
              onClick={onClickHandler}
              title={label}
              style={{ ...arrowStyles, left: 5 }}
            >
              <div className="prev"></div>
            </div>
          )
        }
        renderArrowNext={(onClickHandler, hasNext, label) =>
          hasNext && (
            <div
              className="Btn_right"
              type="button"
              onClick={onClickHandler}
              title={label}
              style={{ ...arrowStyles, right: 5 }}
            >
              <div className="next"></div>
            </div>
          )
        }
      >
        {basePrihodChildren(this.props.payment)}
      </Carousel>
    );
  }
}

const baseRashodChildren = (Payments) =>
  Payments.map((payment, index) => (
    <div key={index} className="carusel_rashod">
      <div><p>{payment.years3}</p> </div>
      <div><p>{payment.rashod}</p></div>
      <div><p>{payment.dates3}</p></div>
      <div><p>{payment.orders3}</p></div>
      <div><p>{payment.vid_opl3}</p></div>
      <div><p>{payment.uslugi3}</p></div>
    </div>
  ));

export class RashodCarouselP extends React.Component {
  render() {
    return (
      <Carousel
        {...getConfigurableProps()}
        selectedItem={this.props.payment.length - 1}
        renderArrowPrev={(onClickHandler, hasPrev, label) =>
          hasPrev && (
            <div
              className="Btn_left"
              type="button"
              onClick={onClickHandler}
              title={label}
              style={{ ...arrowStyles, left: 5 }}
            >
              <div className="prev"></div>
            </div>
          )
        }
        renderArrowNext={(onClickHandler, hasNext, label) =>
          hasNext && (
            <div
              className="Btn_right"
              type="button"
              onClick={onClickHandler}
              title={label}
              style={{ ...arrowStyles, right: 5 }}
            >
              <div className="next"></div>
            </div>
          )
        }
      >
        {baseRashodChildren(this.props.payment)}
      </Carousel>
    );
  }
}